// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

import type { SupportSeverity, SupportStatus } from '../../api/client'

const SEV_COLORS: Record<SupportSeverity, { bg: string; fg: string }> = {
  low:      { bg: '#eef2f1', fg: '#4b5563' },
  normal:   { bg: '#e0f2fe', fg: '#0369a1' },
  high:     { bg: '#fef3c7', fg: '#b45309' },
  critical: { bg: '#fee2e2', fg: '#b91c1c' },
}
// D-SUPPORT-2 Phase A model + legacy values (rows created under phase 1 keep them).
const STATUS_LABELS: Record<SupportStatus, string> = {
  new: 'New', open: 'Open', pending: 'Pending', on_hold: 'On hold', solved: 'Solved', closed: 'Closed',
  triage: 'Triage', in_progress: 'In progress', resolved: 'Resolved',
}
const STATUS_COLORS: Record<SupportStatus, { bg: string; fg: string }> = {
  new:         { bg: '#fce7f3', fg: '#be185d' },
  open:        { bg: '#e0f2fe', fg: '#0369a1' },
  pending:     { bg: '#fef9c3', fg: '#a16207' },  // Zendesk-style yellow: waiting on customer
  on_hold:     { bg: '#e5e7eb', fg: '#374151' },
  solved:      { bg: '#dcfce7', fg: '#15803d' },
  closed:      { bg: '#f1f5f9', fg: '#64748b' },
  // legacy
  triage:      { bg: '#ede9fe', fg: '#6d28d9' },
  in_progress: { bg: '#fef3c7', fg: '#b45309' },
  resolved:    { bg: '#dcfce7', fg: '#15803d' },
}
const pill: React.CSSProperties = { display: 'inline-block', padding: '2px 9px', borderRadius: 999, fontSize: 12, fontWeight: 600, textTransform: 'capitalize' }

export function SeverityBadge({ severity }: { severity: SupportSeverity }) {
  const c = SEV_COLORS[severity] ?? SEV_COLORS.normal
  return <span style={{ ...pill, background: c.bg, color: c.fg }}>{severity}</span>
}
export function StatusBadge({ status }: { status: SupportStatus }) {
  const c = STATUS_COLORS[status] ?? STATUS_COLORS.open
  return <span style={{ ...pill, background: c.bg, color: c.fg }}>{STATUS_LABELS[status] ?? status}</span>
}
